export default {
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
}



// WEBPACK FOOTER //
// ./src/mixins/positionable.js